import {ApiModel} from "../../../../common/api/model/ApiModel";

export class CmpConfigUploadImageResponse extends ApiModel {
    url?: string;
}
